/**
 * Component: sa-product-detail-features
 * Description: Product detail features with desktop hover image swap and mobile stacked items.
 */
if (!customElements.get('sa-product-detail-features')) {
  class SaProductDetailFeatures extends HTMLElement {
    constructor() {
      super();
      this.onItemEnter = this.onItemEnter.bind(this);
      this.enableDesktop = null;
      this.items = [];
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.sa-product-detail-features__item'));
      this.previewImg = this.querySelector('.sa-product-detail-features__preview-img');

      this.enableDesktop = window.matchMedia('(min-width: 1024px)');
      this.handleViewportChange(this.enableDesktop);
      this.enableDesktop.addEventListener('change', (e) => this.handleViewportChange(e));
    }

    disconnectedCallback() {
      if (this.enableDesktop) {
        this.enableDesktop.removeEventListener('change', (e) => this.handleViewportChange(e));
      }
      this.items.forEach((el) => {
        el.removeEventListener('mouseenter', this.onItemEnter);
      });
    }

    handleViewportChange(e) {
      const isDesktop = e.matches === true || e.media === '(min-width: 1024px)' && e.matches === undefined;

      if (isDesktop) {
        this.items.forEach((el) => el.addEventListener('mouseenter', this.onItemEnter));
        const firstActive = this.items[0];
        if (firstActive) {
          this.setActive(firstActive);
        }
      } else {
        this.items.forEach((el) => el.removeEventListener('mouseenter', this.onItemEnter));
        this.items.forEach((el) => el.classList.remove('sa-product-detail-features__item--active'));
      }
    }

    onItemEnter(e) {
      const item = e.currentTarget;
      this.setActive(item);
    }

    setActive(item) {
      this.items.forEach((el) => el.classList.toggle('sa-product-detail-features__item--active', el === item));
      if (this.previewImg) {
        const url = item.getAttribute('data-image-url');
        if (url) {
          this.previewImg.setAttribute('src', url);
        }
      }
    }
  }

  customElements.define('sa-product-detail-features', SaProductDetailFeatures);
}
